import React from 'react';
import styled from 'styled-components';
import { ButtonGroup, Button as RsuiteButton } from 'rsuite';
import { colors } from '../../../../ui';

const UnitToggle = ({ availableUnitTypes, setUnitPreference }) => {
  if (availableUnitTypes.length === 0) {
    return null;
  }

  return (
    <UnitToggleContainer>
      <ToggleLabel>Units:</ToggleLabel>
      {availableUnitTypes.map(({ type, options, current }) => (
        <ToggleGroup key={type}>
          <TypeLabel>{type}:</TypeLabel>
          <ButtonGroup size="xs">
            {options.map(unit => (
              <ToggleButton
                key={unit}
                appearance={current === unit ? 'primary' : 'ghost'}
                active={current === unit}
                onClick={() => setUnitPreference(type, unit)}
              >
                {unit}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </ToggleGroup>
      ))}
    </UnitToggleContainer>
  );
};

const UnitToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

const ToggleLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.neutral[700]};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: ${colors.neutral[50]};
  border-radius: 6px;
  border: 1px solid ${colors.neutral[200]};
`;

const TypeLabel = styled.span`
  font-size: 12px;
  color: ${colors.neutral[600]};
  text-transform: capitalize;
  font-weight: 500;
`;

const ToggleButton = styled(RsuiteButton)`
  font-size: 11px !important;
  padding: 2px 8px !important;
  min-width: 42px;

  &.rs-btn-primary {
    background: ${colors.primary.main} !important;
    color: white !important;
    border-color: ${colors.primary.main} !important;
  }

  &.rs-btn-ghost {
    background: white !important;
    color: ${colors.neutral[600]} !important;
    border-color: ${colors.neutral[300]} !important;

    &:hover {
      background: ${colors.neutral[100]} !important;
      border-color: ${colors.primary.light} !important;
      color: ${colors.primary.main} !important;
    }
  }
`;

export default UnitToggle;
